export default function NavigatorAvatar({ className }: { className: string }) {
  return (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0437843 9.58102C-0.41177 2.27795 2.69788 0 8.88889 0H15.2285C21.3459 0 24 2.11286 24 9.58102C24 16.6611 21.6826 18.7928 16.1664 18.9955C15.892 19.0056 6.00843 18.9955 6.00843 18.9955L6.01551 16.871C3.25247 16.6784 1.71604 15.9399 0.888399 14.1847C0.209312 12.7452 0.00983024 10.6237 0.00983024 7.56373M12.0028 14.0283C12.0085 14.0283 14.797 10.7062 15.8326 9.4782C16.2994 8.92355 16.3985 8.10969 16.3985 7.69841C16.3985 6.19233 15.3685 4.97008 14.0966 4.97008C13.2011 4.97008 12.6069 5.503 12.0028 6.35886C11.3987 5.503 10.7988 4.97877 9.90328 4.97877C8.63141 4.97877 7.60146 6.19957 7.60146 7.7071C7.60146 8.11693 7.70049 8.93224 8.16737 9.48544C9.20297 10.7149 11.9957 14.0283 12.0028 14.0283Z"
        fill="currentColor"
      />
    </svg>
  )
}
